import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOARealEstate() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ realEstatePower, setRealEstatePower ] = useState(powerOfAttorney.real_estate_power || '');
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../tax-matters');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      real_estate_power: realEstatePower
    }));
    navigate('../tangible-property');
  }, [ realEstatePower, setPowerOfAttorney, navigate ]);

  const powerOptions = [
    { 
      value: 'yes', 
      label: 'Yes', 
      description: 'Grant full authority over all real estate transactions' 
    },
    { 
      value: 'yes_no_sell_home', 
      label: 'Yes, but my agent may not sell my home', 
      description: 'Grant authority over real estate except for selling your primary residence' 
    },
    { 
      value: 'no', 
      label: 'No', 
      description: 'Do not grant any real estate powers' 
    }
  ];
  
  return (
    <div className="new-poa-real-estate screen">
      <ScreenHeader
        title="Real Estate Transactions"
        description="Decide whether to grant your agent power over real estate matters"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Real Estate Powers?</h3>
        <p>
          Real estate powers allow your agent to buy, sell, lease, mortgage, and manage 
          real property on your behalf. This includes:
        </p>
        <ul className="powers-list">
          <li>Buying and selling real estate</li>
          <li>Leasing or renting property</li>
          <li>Obtaining mortgages and loans secured by real estate</li>
          <li>Managing rental properties</li>
          <li>Paying property taxes and insurance</li>
          <li>Making repairs and improvements</li>
          <li>Handling real estate disputes and litigation</li>
        </ul>

        <h3>Do You Want to Grant Real Estate Power?</h3>
        <div className="asset-distribution-option-container">
          {powerOptions.map(option => (
            <AssetDistributionOption
              key={option.value}
              id={option.value}
              label={option.label}
              description={option.description}
              value={option.value}
            />
          ))}
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            If you choose to restrict the sale of your home, your agent will still be able 
            to manage other real estate transactions but cannot sell your primary residence 
            without your explicit consent.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
